export interface UserCardReissueRequest {
  id: string
  userId: string
  _updateCardLostCount: boolean
}

export function UserCardReissueRequestToJSON(
  value: UserCardReissueRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    user_id: value.userId !== '' ? value.userId : undefined,
    _update_card_lost_count: value._updateCardLostCount ?? undefined
  }
}
